// extracted by mini-css-extract-plugin
export default {"iconContainer":"RAzmHzMmRVcX8bXBsFjW","icon":"oCao6LqwKwy50P8kCVXT","text":"PQtXGGXhUGWr_skk0lxn"};